const header = document.querySelector('.site-header')

const state = {
  stuck: true,
  prevScroll: window.scrollY || document.documentElement.scrollTop,
  currScroll: 0,
  scrollDir: 0,
  prevDir: 0,
}

const fn = {
  init: () => {
    fn.handleScroll()
    fn.bindEvents()
  },

  bindEvents: () => {
    window.addEventListener('scroll', fn.handleScroll)
  },

  handleScroll: () => {
    const primaryOffset =
      parseInt(getComputedStyle(document.documentElement).getPropertyValue('--secondary-header-height'), 10) +
      parseInt(getComputedStyle(document.documentElement).getPropertyValue('--site-announcement-height'), 10)

    state.currScroll = window.scrollY || document.documentElement.scrollTop
    state.stuck = state.currScroll > primaryOffset

    if (state.currScroll > state.prevScroll + 10) {
      state.scrollDir = 'down'
    } else if (state.currScroll < state.prevScroll - 10) {
      state.scrollDir = 'up'
    }

    state.prevScroll = state.currScroll

    if (state.scrollDir === 'up') {
      document.documentElement.classList.add('is-scrolling-up')
      header.classList.add('is-scrolling-up')
    } else {
      document.documentElement.classList.remove('is-scrolling-up')
      header.classList.remove('is-scrolling-up')
    }

    header.classList.toggle('is-stuck', state.stuck)
  },
}

export default {
  can: () => header,
  run: fn.init,
}
